import { render, staticRenderFns } from "./RoomsBracket.vue?vue&type=template&id=325fd316&scoped=true&"
import script from "./RoomsBracket.vue?vue&type=script&lang=js&"
export * from "./RoomsBracket.vue?vue&type=script&lang=js&"
import style0 from "./RoomsBracket.vue?vue&type=style&index=0&id=325fd316&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325fd316",
  null
  
)

export default component.exports